import { useState, useEffect } from 'react';
import { getRegionsForCountry, type RegionOption } from '@/utils/country-regions';

export type { RegionOption };

interface UseCountryRegionsResult {
  regions: RegionOption[];
  isLoading: boolean;
  error: string | null;
}

/**
 * Returns static ISO 3166-2 subdivision data for a given country code.
 * Synchronous lookup — no API call needed.
 */
export function useCountryRegions(countryCode: string | null | undefined): UseCountryRegionsResult {
  const [regions, setRegions] = useState<RegionOption[]>([]);

  useEffect(() => {
    if (!countryCode || countryCode.length !== 2) {
      setRegions([]);
      return;
    }
    setRegions(getRegionsForCountry(countryCode));
  }, [countryCode]);

  return { regions, isLoading: false, error: null };
}
